import React, { useState } from "react";
import { SitemapService } from '../../services/sitemapServices';
import { WebhookService } from '../../services/webhooksService';
import UnifiedCard from '../ui/UnifiedCard/UnifiedCard';
import './SitemapManager.sass'; // ✅ AGREGAR ESTA LÍNEA

const SitemapManager = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [lastGenerated, setLastGenerated] = useState(null);

  const handleGenerateSitemap = async () => {
    setIsGenerating(true);
    try {
      await SitemapService.generateDynamicSitemap();
      await SitemapService.submitSitemapToSearchEngines();
      setLastGenerated(new Date().toLocaleString());
    } catch (error) {
      console.error('Error generando sitemap:', error);
    } finally {
      setIsGenerating(false);
    }
  };

  const handleRegenerateSitemap = async () => {
    setIsGenerating(true);
    try {
      await WebhookService.triggerSitemapRegeneration();
      setLastGenerated(new Date().toLocaleString());
    } catch (error) {
      console.error('Error regenerando sitemap:', error);
    } finally {
      setIsGenerating(false);
    }
  };

  const sitemapCards = [
    {
      title: "Sitemap Principal",
      description: "Páginas principales y estáticas del sitio",
      url: "/sitemap.xml",
      icon: "🗂️"
    },
    {
      title: "Sitemap Propiedades", 
      description: "Todas las propiedades disponibles",
      url: "/sitemap-properties.xml",
      icon: "🏠"
    },
    {
      title: "Sitemap Ciudades",
      description: "Búsquedas por ciudades disponibles", 
      url: "/sitemap-cities.xml",
      icon: "🏙️"
    },
    {
      title: "Índice de Sitemaps",
      description: "Índice general de todos los sitemaps",
      url: "/sitemap-index.xml", 
      icon: "📋"
    }
  ];

  return (
    <div className="sitemap-manager">
      <div className="sitemap-manager__header">
        <h2>🗺️ Gestión de Sitemaps SEO</h2>
        <p>Administra y regenera los sitemaps para optimizar el SEO del sitio</p>
      </div>

      {/* Action Cards */}
      <div className="sitemap-manager__actions">
        <UnifiedCard
          variant="admin"
          title="Generar Sitemap"
          description="Crear nuevo sitemap dinámico con todas las propiedades actuales"
          loading={isGenerating}
          onClick={handleGenerateSitemap}
          badge={isGenerating ? "Generando..." : "Acción"}
        >
          <div className="action-button">
            <span className="action-icon">🚀</span>
            {isGenerating ? 'Generando...' : 'Generar Sitemap Dinámico'}
          </div>
        </UnifiedCard>

        <UnifiedCard
          variant="admin"
          title="Regenerar Manual"
          description="Forzar regeneración manual del sitemap (usar solo si es necesario)"
          loading={isGenerating}
          onClick={handleRegenerateSitemap}
          badge="Manual"
        >
          <div className="action-button secondary">
            <span className="action-icon">🔄</span>
            {isGenerating ? 'Regenerando...' : 'Regenerar Manualmente'}
          </div>
        </UnifiedCard>
      </div>

      {/* Status */}
      {lastGenerated && (
        <div className="sitemap-manager__status">
          <div className="status-badge success">
            ✅ Última actualización: {lastGenerated}
          </div>
        </div>
      )}

      {/* Sitemap Links */}
      <div className="sitemap-manager__links">
        <h3>📁 Sitemaps Generados</h3>
        <div className="sitemap-grid">
          {sitemapCards.map((sitemap, index) => (
            <UnifiedCard
              key={index}
              variant="info"
              title={sitemap.title}
              description={sitemap.description}
              url={sitemap.url}
              badge="Ver"
            >
              <div className="sitemap-card-content">
                <span className="sitemap-icon">{sitemap.icon}</span>
                <span className="sitemap-url">{sitemap.url}</span>
              </div>
            </UnifiedCard>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SitemapManager;